import { render } from "./LikeBtn.vue?vue&type=template&id=124271a4&scoped=true"
import script from "./LikeBtn.vue?vue&type=script&lang=js"
export * from "./LikeBtn.vue?vue&type=script&lang=js"

import "./LikeBtn.vue?vue&type=style&index=0&id=124271a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124271a4"]])

export default __exports__